var core = require('../../modules/$.core');
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/json/stringify.js
// module id = 588
// module chunks = 0